export default __webpack_public_path__ + "static/Saturday-b7f4d48eb19870bbe5dcc509162e150f.png";